<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="htp01">
<h2 class="halfTitlePageTitle" style="text-indent: 0%;"><span class="bold">HOW THE RICH GET THIN</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312340391_htp01.vue?bda2b4e2